import type { Trip, TripList } from '@bambi/api-client/schemas';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';

import { onPriceSummaryModalOpen } from '../pricing.slice';
import { useAppDispatch } from 'src/app/store/hooks';

export function PriceSummaryModalButton({ trip }: { trip: Trip | TripList }) {
  const dispatch = useAppDispatch();

  return (
    <CurrencyDollarIcon
      data-testid="price-summary-modal-button"
      className="h-6 w-6 hover:cursor-pointer"
      onClick={() => dispatch(onPriceSummaryModalOpen(trip))}
    />
  );
}
